import { useAutovioContext } from "./useAutovioContext";

export function useCurrentDrivingSchoolId(): string {
  const [{ drivingSchoolId }] = useAutovioContext();
  if (!drivingSchoolId) {
    throw new Error("No current driving school");
  }
  return drivingSchoolId;
}
